import InvitationForm from "./components/InvitationForm";

export default {
    components: {
        'invitation-form': InvitationForm
    }
}
